import React from 'react'

const AffiliateProgramSettingsSkeleton = () => (
  <div className="bg-background-secondary flex h-fit w-full flex-col gap-7 overflow-x-hidden rounded-md p-5 [&>*]:flex-1">
    <div className={'flex flex-col gap-2'}>
      <div className={'bg-skeleton-primary animate-pulse rounded-md text-transparent'}>.</div>{' '}
      <div className={'bg-skeleton-primary animate-pulse rounded-md text-transparent'}>.</div>
    </div>
    <div className={'flex w-full flex-col gap-7 xl:flex-row xl:items-end [&>*]:flex-1'}>
      <div
        className={'bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent'}
      >
        .
      </div>
      <div
        className={'bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent'}
      >
        .
      </div>
    </div>
    <div className={'flex w-full flex-col gap-7 xl:flex-row xl:items-end [&>*]:flex-1'}>
      <div
        className={'bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent'}
      >
        .
      </div>
      <div
        className={'bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent'}
      >
        .
      </div>
    </div>
    <div className={'bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent'}>
      .
    </div>
    <div className={'bg-skeleton-primary animate-pulse rounded-md py-[1.5px] text-transparent'}>
      .
    </div>
  </div>
)

export default AffiliateProgramSettingsSkeleton
